import React from 'react';

import { Tabs } from 'antd';

// import commonConfig from '../../../commonConfig.json';
import "./MainCanvas.css";

const { TabPane } = Tabs;

const MainCanvas = props => {
    let appNameDiv = (<div className="canvasAppName" >{props.appName}</div>)
    let appContent = (<div className="canvasContent" >{props.children}</div>);
    let appCanvas = <></>;
    if(props.canvasType === "tabs"){
        appCanvas = (
            <>
                <Tabs 
                    className={props.canvasData.tabPosition === "right" ? "rightTabCanvas" : "leftTabCanvas"} 
                    tabBarExtraContent={props.canvasData.tabPosition === "right" ? {left:appNameDiv} :""} 
                    activeKey={props.canvasData.active} 
                    onChange={(key)=>props.canvasCallback(key)}
                >
                {props.canvasData.list.map(d => {
                    return <TabPane tab={d.value} key={d.key} disabled={props.canvasData.disabled.includes(d.key)}></TabPane>
                })}
                </Tabs>
                {appContent}
            </>
            
        );  
    } else if(props.canvasType === "plain"){
        appCanvas = (
            <>
                {appNameDiv}
                {appContent}
            </>
        );
    }
    return appCanvas
}


export default React.memo(MainCanvas);
